import enUS from './en-us'
import ruRU from './ru-ru'

export default {
  'en-us': enUS,
  'ru-ru': ruRU
}
